import PageBuilder from '@commons/pagebuilder';
import { type DrupalBlock, type DrupalView } from '@commons/types/drupal';

import type { Block } from '..';

// Type definition for the ViewReference block properties.

type Props = DrupalBlock<DrupalView>;

/**
 * ViewReference block component.
 */

const ViewReferenceBlock: Block = ({ content }: Props) => {
  return PageBuilder.renderView(content);
};

export default ViewReferenceBlock;
